import React from 'react';
import MkStars from './MkStars';
import { displayName } from '../../marketing/reviews';

// A verbatim Google Play review of Keep Me Out. No avatars. variant: 'featured' | 'compact'.
const MkReviewCard = ({ review, variant, className }) => (
  <figure className={['mk-review', variant && `mk-review--${variant}`, className].filter(Boolean).join(' ')}>
    <svg className="mk-review__mark" width="28" height="28" viewBox="0 0 28 28" aria-hidden="true" focusable="false">
      <path d="M11.5 6.5C7.6 8 5.5 11 5.5 15.3v6.2h6.8v-6.8H9.1c.1-2.6 1.2-4.2 3.3-5l-.9-3.2zm11 0C18.6 8 16.5 11 16.5 15.3v6.2h6.8v-6.8h-3.2c.1-2.6 1.2-4.2 3.3-5l-.9-3.2z" />
    </svg>
    <MkStars value={review.stars} />
    <blockquote className="mk-quote">
      <p>{review.text}</p>
    </blockquote>
    <figcaption className="mk-micro mk-review__by">
      {displayName(review)} · Google Play · {review.month}
    </figcaption>
  </figure>
);

export default MkReviewCard;
